// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3Fss8","clinicsSelect":"TableHeading_clinicsSelect__3Eks_"};